import type { JsonSchema } from "@jsonforms/core";
import type Ajv from "ajv/dist/2020";
import type { ErrorObject } from "ajv";

export type CatalogUiError = ErrorObject & {
  ruleId?: string;
  dependencies?: string[];
  requirementField?: string;
  e2bRule?: boolean;
};

// case.product.rule.authorization_number_required
// case.product.rule.authorization_country_required
// case.product.rule.market_authorization_holder_required
// share this path. Conditions and messages are generated from validation.json, never copied here.
export function conditionalRequiredFields(schema: JsonSchema, values: unknown, ajv: Ajv): Set<string> {
  const required = new Set<string>();
  for (const fragment of schema.allOf ?? []) {
    const rule = fragment as JsonSchema & { if?: JsonSchema; then?: JsonSchema; "x-rule-e2b"?: boolean };
    // An E2B conformance condition is reported by server readiness, never as a client-side blocker.
    if (rule["x-rule-e2b"] === true) continue;
    if (rule.if && ajv.validate(rule.if, values)) {
      for (const name of rule.then?.required ?? []) required.add(name);
    }
  }
  return required;
}

export function catalogErrorApplies(error: CatalogUiError, submitted: Set<string>, field: string): boolean {
  // An E2B conformance condition is reported by server readiness, never as a client-side blocker.
  if (error.e2bRule) return false;
  return error.dependencies ? error.dependencies.some((key) => submitted.has(key)) : submitted.has(field);
}
